// RouteMetaTags.jsx
import React from 'react';
import { useMatches } from 'react-router';

import {
  renderHeadMetaElements,
  renderJsonLdElements,
} from '../resource/metaDescriptorElements.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';

export const RouteMetaTags = () => {
  const matches = useMatches();
  // Deepest-wins dedupe (like server collectRouteMeta.js): render the meta of
  // the deepest matched route that provides one. Rendered once at the app root
  // (App.jsx), so there is no per-route instance to duplicate head tags.
  const metaTags =
    matches
      .filter(
        match => Array.isArray(match?.data?.meta) && match.data.meta.length
      )
      .pop()?.data?.meta ?? EMPTY_ARRAY;

  if (metaTags.length === 0) {
    return null;
  }

  return (
    <>
      {/* Hoistable head tags are client-only: React 19 hoists them into
          <head>, where hydration adopts the tags the SSR template already
          emitted from the same descriptors (renderHtml.js). Rendering them
          on the server would duplicate them at the top of #app-root, since
          renderToString hoists them to the front of its output. */}
      {typeof window === 'undefined'
        ? null
        : renderHeadMetaElements({ metaTags })}
      {renderJsonLdElements({ metaTags })}
    </>
  );
};

export default RouteMetaTags;
